import { observer } from 'mobx-react';
import { Grid, makeStyles, Box, Button, Toolbar } from '@material-ui/core';
import { getPostClosingActionHandlers } from './getPostClosingActionHandlers';
import { PostClosingTabsEnum } from '../constants/tabs';

const useStyles = makeStyles(() => ({
  button: {
    backgroundColor: '#2D4B89',
    color: '#fff',
    borderRadius: '5px',
    marginLeft: '8px',
    textTransform: 'uppercase',
    fontWeight: 500,
    '&:hover': {
      backgroundColor: '#1E355F',
    },
    '&.Mui-disabled': {
      backgroundColor: '#B0B9D6',
      color: '#ffffff',
      opacity: 0.7,
    },
  },
}));

export const PostClosingToolbar = observer(({ store }) => {
  const classes = useStyles();
  const tabValue = store.tab;
  const isDisabled = store.selectedLoanIds.length === 0;
  const handlers = getPostClosingActionHandlers({
    selectedRows: store.selectedLoanIds,
    tabValue,
    excelDashboard: {
      urlParams: store.postClosingGridStore?.gridData?.meta?.urlParams,
    },
    exportDashboardService: (...args) => store.service.exportDashboard(...args),
    openLoanActionModal: store.openLoanActionModal,
    openLoanDateModal: store.openLoanDateModal,
    openLoanNumberModal: store.openLoanNumberModal,
    setNotification: msg =>
      store.globalStore.notificationStore.showErrorNotification({
        message: msg,
      }),
   openLoanSpecialistModal: (...args) => store.openLoanSpecialistModal(...args),
  });

  return (
    <Grid container>
      <Grid item xs={12}>
        <Toolbar style={{ justifyContent: 'flex-end', paddingLeft: 0 }}>
          <Box display="flex">
            {tabValue === PostClosingTabsEnum.COLLATERAL_MANAGEMENT && (
              <>
                <Button
                  size="small"
                  onClick={handlers.originalDocReceived}
                  className={classes.button}
                  disabled={isDisabled}
                >
                  Original Doc Received
                </Button>
                <Button
                  size="small"
                  onClick={handlers.isEfileCompleted}
                  className={classes.button}
                  disabled={isDisabled}
                >
                  E-File Completed
                </Button>
                <Button
                  size="small"
                  onClick={handlers.custodial}
                  className={classes.button}
                  disabled={isDisabled}
                >
                  Custodial
                </Button>
                <Button
                  size="small"
                  onClick={handlers.custodialShipDate}
                  className={classes.button}
                  disabled={isDisabled}
                >
                  Ship Date
                </Button>
                <Button
                  size="small"
                  onClick={handlers.custodialTrackingNumber}
                  className={classes.button}
                  disabled={isDisabled}
                >
                  Tracking Number
                </Button>
              </>
            )}
            {tabValue === PostClosingTabsEnum.SPECIALIST_REASSIGNMENT && (
              <Button
                size="small"
                onClick={handlers.updatePostClosingSpecialist}
                className={classes.button}
                disabled={isDisabled}
              >
                Reassign Specialist
              </Button>
            )}
            {tabValue !== PostClosingTabsEnum.SPECIALIST_REASSIGNMENT && (
            <Button
              size="small"
              onClick={handlers.onDashboardExport}
              className={classes.button}
            >
              Export as Excel
            </Button>
            )}
          </Box>
        </Toolbar>
      </Grid>
    </Grid>
  );
});
